import React from "react";

type SkeletonVariant = "text" | "card" | "circle" | "bar" | "page" | "page-legacy";

interface LoadingSkeletonProps {
  variant?: SkeletonVariant;
  count?: number;
  width?: string;
  height?: string;
  className?: string;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({
  variant = "text",
  count = 1,
  width,
  height,
  className = "",
}) => {
  const items = Array.from({ length: count }, (_, i) => i);

  if (variant === "page") {
    // Full-page waits get a branded loader: the old dark skeleton blocks on a
    // dark background read as a broken black screen.
    return (
      <div className={`app-loader ${className}`} role="status" aria-live="polite" aria-label="Loading">
        <img
          className="app-loader__logo"
          src="https://moonrock-images.s3.us-east-2.amazonaws.com/moonrock-logo-new2.png"
          alt=""
          aria-hidden="true"
        />
        <div className="app-loader__spinner" aria-hidden="true" />
        <div className="app-loader__text">Loading…</div>
      </div>
    );
  }

  if (variant === "page-legacy") {
    return (
      <div className={`skeleton-page ${className}`}>
        <div className="skeleton-bar skeleton-pulse" style={{ width: "60%", height: "24px", marginBottom: "16px" }} />
        <div className="skeleton-bar skeleton-pulse" style={{ width: "40%", height: "16px", marginBottom: "24px" }} />
        <div className="skeleton-cards-row">
          {[0, 1, 2].map((i) => (
            <div key={i} className="skeleton-card skeleton-pulse" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={`skeleton-wrapper ${className}`}>
      {items.map((i) => (
        <div
          key={i}
          className={`skeleton-${variant} skeleton-pulse`}
          style={{
            width: width || (variant === "circle" ? "48px" : "100%"),
            height: height || (variant === "circle" ? "48px" : variant === "card" ? "120px" : "16px"),
          }}
        />
      ))}
    </div>
  );
};

export default LoadingSkeleton;
